import { connect } from 'react-redux';

import DetailedEPReport from 'components/DetailedEPReport';

import { getUserRole } from 'store/selectors/user';
import { reportsSubmitDetailedEpForm } from 'store/actionCreators/reports/singleItems';
import {
  getReportDetailedFormInitialValues,
  getReportItemStatus,
} from 'store/selectors/reports/singleItems';

const mapStateToProps = (state, { reportId }) => ({
  reportStatus: getReportItemStatus(reportId)(state),
  role: getUserRole(state),
  initialValues: getReportDetailedFormInitialValues(reportId)(state),
});

const mapDispatchToProps = (dispatch, { reportId }) => ({
  onSubmit: () => dispatch(reportsSubmitDetailedEpForm({ reportId })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DetailedEPReport);
